import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var BusSchool = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M21.259 11.948A.986.986 0 0022 11V8a.999.999 0 00-.996-.999V6H21c0-2.206-1.794-4-4-4H7C4.794 2 3 3.794 3 6v1a1 1 0 00-1 1v3c0 .461.317.832.742.948a3.953 3.953 0 00-.741 2.298l.004 3.757c.001.733.404 1.369.995 1.716V21a1 1 0 001 1h1a1 1 0 001-1v-1h12v1a1 1 0 001 1h1a1 1 0 001-1v-1.274a2.02 2.02 0 00.421-.313c.377-.378.585-.881.584-1.415l-.004-3.759a3.966 3.966 0 00-.742-2.291zM5 18h-.995l-.004-3.757c-.001-.459.161-.89.443-1.243H19.555c.283.353.445.783.446 1.242L20.006 18H5zm6.004-10v3H5V8h6.004zM19 11h-5.996V8H19v3zM7 4h10c1.103 0 2 .897 2 2h-4V5H9v1H5c0-1.103.897-2 2-2z",
    key: "k0"
  }), React.createElement("circle", {
    cx: 6.5,
    cy: 15.5,
    r: 1.5,
    key: "k1"
  }), React.createElement("circle", {
    cx: 17.5,
    cy: 15.5,
    r: 1.5,
    key: "k2"
  }));
});
BusSchool.displayName = 'BusSchool';
export var BusSchoolDimensions = {
  height: 24,
  width: 24
};